<template>
  <div>
    <div class="activate4_box">
      <div class="list_box">
        <div class="title_box">
          <div class="contract_type">{{$t('full_position')}}</div>
          <div class="contract_level" @click="openLevel(1)">{{ levelLimit }}x</div>
        </div>
        <div class="openC">
          <div class="openItem open darkMode">
            <span :class="'openItemTitle openTitle darkMode '+ (isOpenLimit?'active':'')"
                  @click="isOpenLimit=true">{{$t("open_position")}}</span>
          </div>
          <div class="openItemBox darkMode"></div>
          <div class="openItem close darkMode">
            <span :class="'openItemTitle closeTitle darkMode '+(!isOpenLimit?'active':'')" @click="isOpenLimit=false;">{{$t("close_position")}}</span>
          </div>
        </div>
        <div class="titile">{{ $t('limit_order_label') }}</div>
        <div class="top_box">
          <div class="jyd">
            <span>{{ $t('trading_pair') }}</span>
            <el-select class="jyd_select select_down" v-model="value" popper-class="custom-select-dropdown">
              <el-option v-for="item in options" :key="item.value" :label="item.label" :value="item.value">
              </el-option>
            </el-select>
          </div>
          <div class="price">
            <span>{{ $t('current_price') }}</span>
            <span class="nu">{{ currentLimitPrice }}</span>
          </div>
        </div>
        <div class="ttt2">{{ $t('order_price') }}</div>
        <div class="order_price_box" v-click-outside="closeModal">
          <span class="ttt">{{ $t('order_price') }}</span>
          <el-input v-model="limitPrice" :placeholder="$t('enter_content')" ></el-input>
          <span class="new" style="cursor: pointer" @click="updateLimitPrice">|&nbsp;&nbsp;{{ $t('latest') }}</span>
          <span style="cursor: pointer" @click="openModal">
            <span>+</span>
            <span>/</span>
            <span>-</span>
          </span>
          <div class="grid_box" v-if="showModal">
            <div class="grid_list" style="font-size: 20px">+</div>
            <div class="grid_list" style="font-size: 20px">-</div>
            <div class="grid_list" @click="add(5)">+5</div>
            <div class="grid_list" @click="add(-5)">-5</div>
            <div class="grid_list" @click="add(20)">+20</div>
            <div class="grid_list" @click="add(-20)">-20</div>
            <div class="grid_list" @click="clearPrice">C</div>
            <div class="grid_list" @click="returnPrice">
              <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5"
                   stroke="currentColor" class="w-6 h-6 inline-block">
                <path stroke-linecap="round" stroke-linejoin="round" d="M9 15L3 9m0 0l6-6M3 9h12a6 6 0 010 12h-3"/>
              </svg>
            </div>
          </div>
        </div>
        <div class="ttt2">{{ $t("order_quantity") }}</div>
        <div class="order_price_box">
          <span class="ttt">{{ $t('order_quantity') }}</span>
          <el-input v-model="limitNum" :placeholder="$t('enter_content')" @focus="clear(1)"></el-input>
          <span :class="'new ' +(isOpenLimit?'':'willHide')" style="white-space: nowrap;cursor: pointer;width: revert"
                @click="setLimitMax">|&nbsp;&nbsp;{{ $t('maximum_value') }}</span>
        </div>
        <draggable-progress v-model="progressLimit" :content="['0','100%']"/>
        <div class="list" style="margin-top: 44px">
          <div class="left line"><span>{{ isOpenLimit ? $t("max_openable") : $t("max_close_long_short") }}</span></div>
          <div class="right line">
            {{
              isOpenLimit ? maxLimit : (value == "BTC" ? (transBig2number(maxLongBTC,18,4) + "/" + transBig2number(maxShortBTC,18,4)) : (transBig2number(maxLongETH,18,4) + "/" + transBig2number(maxShortETH,18,4)))
            }}<span
              style="margin-left: 10px;color:#A6A6A6">{{ value }}</span></div>
        </div>
        <div :class="(isOpenLimit?'':'willHide')+' list'" style="margin-top: 14px">
          <div class="left line">
            <span>{{$t("margin")}}</span>
          </div>
          <div class="right line">{{ marginLimit }}<span
              style="margin-left: 10px;color:#A6A6A6">{{ tableData4[0].coin }}</span></div>
        </div>

        <div :class="((!isOpenLimit&&(parseFloat(transBig2number(closeLimitLongAmount,18,4))>0 || parseFloat(transBig2number(closeLimitShortAmount,18,4))>0))?'':'willHide')+' list'" style="margin-top: 14px">
          <div class="left line">
            <span>{{$t("close_long")}} </span>
            <span>{{ transBig2number(closeLimitLongAmount,18,4) }}</span>
          </div>
          <div class="right line" >
            <span style="color: rgba(132, 142, 156, 1);border-bottom: revert;">{{$t('close_short')}} </span>
            <span style="color: rgba(132, 142, 156, 1);border-bottom: revert;margin-left: 6px;"> {{ transBig2number(closeLimitShortAmount,18,4) }}</span>
          </div>
        </div>

        <div class="btn_box">
          <div class="btnm" @click="open(1,true)" style="margin-right: 10px">
            {{ isOpenLimit ? $t('long_position') : $t("close_long") }}
          </div>
          <div class="btnm" @click="open(1,false)" style="margin-left:10px;background: rgba(239, 69, 74, 1);">
            {{ isOpenLimit ? $t('short_position') : $t('close_short') }}
          </div>
        </div>
      </div>
      <div class="list_box">
        <div class="title_box">
          <div class="contract_type">{{$t('full_position')}}</div>
          <div class="contract_level" @click="openLevel(2)">{{ levelMarket }}x</div>
        </div>
        <div class="openC">
          <div class="openItem open darkMode">
            <span :class="'openItemTitle openTitle darkMode '+ (isOpenMarket?'active':'')"
                  @click="isOpenMarket=true">{{$t("open_position")}}</span>
          </div>
          <div class="openItemBox darkMode"></div>
          <div class="openItem close darkMode">
            <span :class="'openItemTitle closeTitle darkMode '+(!isOpenMarket?'active':'')"
                  @click="isOpenMarket=false;">{{$t("close_position")}}</span>
          </div>
        </div>
        <div class="titile">{{ $t('market_order_label') }}</div>
        <div class="top_box">
          <div class="jyd">
            <span>{{ $t('trading_pair') }}</span>
            <el-select v-model="marketValue" class="jyd_select select_down" popper-class="custom-select-dropdown">
              <el-option v-for="item in options" :key="item.value" :label="item.label" :value="item.value">
              </el-option>
            </el-select>
          </div>
          <div class="price">
            <span>{{ $t('current_price') }}</span>
            <span class="nu">
              {{ currentPrice }}
            </span>
          </div>
        </div>
        <div class="ttt2">{{ $t("order_price") }}</div>
        <div class="order_price_box" style="background: #26282C;">
          <span class="ttt">{{ $t("order_price") }}</span>
          <!--          <el-input v-model="currentPrice" :placeholder="$t('enter_content')"></el-input>-->
          <div style="flex: 1;"></div>
          <span class="new">{{ $t("market_order") }}</span>
        </div>
        <div class="ttt2">{{ $t("order_quantity") }}</div>
        <div class="order_price_box">
          <span class="ttt">{{ $t("order_quantity") }}</span>
          <el-input v-model="marketNum" :placeholder="$t('enter_content')" @focus="clear(2)"></el-input>
          <span :class="'new2 '+(isOpenMarket?'':'willHide')" style="white-space: nowrap;cursor: pointer"
                @click="setMarketMax">|&nbsp;&nbsp;{{ $t("maximum_value") }}</span>
        </div>
        <draggable-progress v-model="progressMarket" :content="['0','100%']"/>

        <div class="list" style="margin-top: 44px">
          <div class="left line"><span>{{ isOpenMarket ? $t("max_openable") : $t("max_close_long_short") }}</span></div>
          <div class="right line">
            {{
              isOpenMarket ? maxMarket : (marketValue == "BTC" ? (transBig2number(maxLongBTC,18,4) + "/" + transBig2number(maxShortBTC,18,4)) : (transBig2number(maxLongETH,18,4) + "/" + transBig2number(maxShortETH,18,4)))
            }}<span
              style="margin-left: 10px;color:#A6A6A6">{{ marketValue }}</span></div>
        </div>
        <div :class="(isOpenMarket?'':'willHide')+' list'" style="margin-top: 14px">
          <div class="left line">
            <span>{{$t("margin")}}</span>
          </div>
          <div class="right line">{{ marginMarket }}<span
              style="margin-left: 10px;color:#A6A6A6">{{ tableData4[0].coin }}</span></div>
        </div>
        <div :class="((!isOpenMarket &&(parseFloat(transBig2number(closeMarketShortAmount,18,4))>0 || parseFloat(transBig2number(closeMarketLongAmount,18,4))>0))?'':'willHide')+' list'" style="margin-top: 14px">
          <div class="left line">
            <span>{{$t("close_long")}}</span>
            <span>{{ transBig2number(closeMarketLongAmount,18,4) }}</span>
          </div>
          <div class="right line">
            <span style="color: rgba(132, 142, 156, 1);border-bottom: revert;">{{$t('close_short')}}</span>
            <span style="color:rgba(132, 142, 156, 1);border-bottom: revert;margin-left: 6px;"> {{ transBig2number(closeMarketShortAmount,18,4) }}</span>
          </div>
        </div>
        <div class="btn_box">
          <div class="btnm" @click="open(2,true)" style="margin-right: 10px">
            {{ isOpenMarket ? $t('long_position') : $t("close_long") }}
          </div>
          <div class="btnm" @click="open(2,false)" style="margin-left:10px;background: rgba(239, 69, 74, 1);">
            {{ isOpenMarket ? $t("short_position") : $t('close_short') }}
          </div>
        </div>
      </div>
    </div>

    <el-dialog :modal="false" :title="this.tableData4[0].coin+'/'+(openType==1?this.value:marketValue)"
               :visible.sync="dialogVisible">
      <div class="dialog_title"><span class="more" v-if="this.isBuy">{{(openType==1?isOpenLimit:isOpenMarket)?$t('long_position'):$t("close_long") }}</span> <span
          v-if="!this.isBuy" class="less">{{ (openType==1?isOpenLimit:isOpenMarket)?$t("short_position"):$t('close_short') }}</span></div>
      <div>
        <div class="dialog_list">
          <div class="left">{{ $t("price") }}</div>
          <div class="right">{{ openType == 1 ? this.limitPrice : $t('market_order') }}</div>
        </div>
        <div class="dialog_list">
          <div class="left">{{ $t('quantity') }}</div>
          <div class="right">{{ openType == 1 ? (isOpenLimit?limitNum:(isBuy?transBig2number(closeLimitLongAmount,18,4):transBig2number(closeLimitShortAmount,18,4))) :  (isOpenMarket?marketNum:(isBuy?transBig2number(closeMarketLongAmount,18,4):transBig2number(closeMarketShortAmount,18,4))) }}</div>
        </div>

        <div :class="'dialog_list ' + ((openType==1?isOpenLimit:isOpenMarket)?'':'willHide')">
          <div class="left">{{$t("margin")}}</div>
          <div class="right">{{ this.openType == 1 ? this.marginLimit : this.marginMarket }}</div>
        </div>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button style="background: #C6FE61;color: #181A20" type="primary"
                   @click="ok1()">{{ $t("confirm") }}</el-button>
      </span>
    </el-dialog>

    <el-dialog :visible.sync="levelVisible" :title="$t('adjust_leverage')" width="470px">
      <div class="level_content">
        <div class="level_title">{{$t("leverage")}}</div>
        <div class="level">
          <div class="level_add" @click="addLevel(1)">-</div>
          <div class="level_num">{{ changeLevel }}x</div>
          <div class="level_sub" @click="addLevel(2)">+</div>
        </div>
        <draggable-progress v-model="changeLevel" :units="'x'" :content="['1x','25x','50x','75x','100x']"/>
        <div class="level_confirm" @click="doChangeLevel">{{$t('confirm')}}</div>
      </div>
    </el-dialog>

  </div>
</template>

<script>
import {
  createAndCall,
  createLeadingContractAndSend, createOrderBookAndCall,
  createPerpOptionAndCall, createTradeAndCall,
  createUnderlingAndCall, getAllTokenFromCache, getContractOrder,
  getErc20Info, getGasReward, getSelectTokenInfo, getValue
} from "../utils/contract";
import {ADDRESS_ZERO, Contract, Method, Underling} from "../config/const";
import {getLastPrice, registerService, removeService} from "../service/priceService";
import {transBig2number, transNumber2Big} from "../utils/functions";
import {ethers} from "ethers";
import config from "../config/config";
import {getChainId} from "../utils/wallet";

import DraggableProgress from '../components/DraggableProgress';
import scheduleContainer from '../components/scheduleContainer';
import {nextTick} from "vue";
import {BigNumber} from "ethers";
import {emmitMessage, emmitMessageWithDelay, MESSAGE} from "../utils/message";

export default {
  name: "activate4",
  props: {
    contractAddress: "",
    token: "",
  },

  components: {
    DraggableProgress,
    scheduleContainer
  },
  computed: {
  },
  data() {
    return {
      progressValue: 0,
      progressValue2: 29,
      isDragging: false,
      isDragging2: false,
      levelVisible: false,
      sliderWidth: 0,
      sliderWidth2: 0,
      handleLeft: 0,
      handleLeft2: 0,
      containerWidth: 300, // Width of the slider container
      containerWidth2: 300, // Width of the slider container
      tableData4: [
        {
          order: '',
          deal: '',
          coin: '',
          type: 1,
          open: 0,
          price: '',
          price2: '',
          pan: '',
          nextTime: '',
          timePrice: 0,
          operate: 0
        },
      ],
      currentPage: 1,
      leftBL: '20%',
      input: '121212',
      value: 'BTC',
      marketValue: "BTC",
      options: [
        {
          value: 'BTC',
          label: 'BTC'
        },
        {
          value: 'ETH',
          label: 'ETH'
        },
      ],
      currentPrice: "0",
      limitPrice: "",
      limitNum: "",
      marketNum: "",
      maxLimit: 0,
      maxMarket: 0,
      estimateLimit: 0,
      estimateMarket: 0,
      foundFeeLimit: 0,
      foundFeeMarket: 0,
      dialogVisible: false,
      openType: 1,  // 0市价 1 限价
      isBuy: true,
      isOpen:true,
      loading: false,
      showModal: false,
      limitPriceArr: [],
      currentLimitPrice: 0,
      decimals: 18,
      viewInit: false,
      tradeAgent: "",
      levelMarket: 100,
      levelLimit: 100,
      levelETH: 100,
      levelBTC: 100,
      changeLevel: 100,
      changeLevelType: 1,
      optionAddress: "",
      marginLimit: "0",
      marginMarket: "0",
      isOpenLimit: true,
      isOpenMarket: true,
      maxLongBTC: BigNumber.from(0),
      maxLongETH: BigNumber.from(0),
      maxShortBTC: BigNumber.from(0),
      maxShortETH: BigNumber.from(0),
      closeLimitLongAmount: BigNumber.from(0),
      closeLimitShortAmount: BigNumber.from(0),
      closeMarketLongAmount: BigNumber.from(0),
      closeMarketShortAmount: BigNumber.from(0),
      progressLimit:0,
      progressMarket:0
    }
  },
  mounted() {
    // this.containerWidth = this.$refs.sliderContainer.offsetWidth;
    // this.containerWidth2 = this.$refs.sliderContainer.offsetWidth;
    registerService( this.updatePrice)
  },
  unmounted() {
    removeService(this.updatePrice)
  },
  methods: {
    transBig2number,

    setStop(isStop) {
      this.viewInit = isStop;
    },

    async updateLimitPrice() {
      let priceData = await getLastPrice();
      let currPrice = transBig2number(priceData[this.value].price, priceData[this.value].decimal);
      this.limitPrice = currPrice;
    },
    async clear(type){
      if(type==1){
        this.progressLimit=0
        await nextTick()
        this.limitNum=""
        this.closeLimitShortAmount=BigNumber.from(0)
        this.closeLimitLongAmount=BigNumber.from(0)
      }else{
        this.progressMarket=0
        await nextTick()
        this.marketNum=""
        this.closeMarketLongAmount=BigNumber.from(0)
        this.closeMarketShortAmount=BigNumber.from(0)
      }

    },
    async getDataInfo() {
      if (!this.contractAddress) {
        return;
      }
      if (!this.token) {
        return;
      }

      let allToken = await getAllTokenFromCache();
      let tokenInfo = await getSelectTokenInfo(this.token);
      if (!tokenInfo) {
        return;
      }
      this.optionAddress = tokenInfo.perpetual;
      this.tradeAgent = tokenInfo.tradeAgent;
      if (!this.optionAddress) {
        return;
      }


      let tokenSymbols = await getErc20Info([this.token]);
      let tokenDecimals = await getErc20Info([this.token], Method.decimals)
      this.decimals = tokenDecimals[0];
      this.tableData4[0].coin = tokenSymbols[0];

      this.tableData4[0].order = this.token;

      let accountInfo = await createPerpOptionAndCall(this.optionAddress, Method.getAccountInfo,this.token, this.contractAddress);


      if (accountInfo) {
        this.tableData4[0].price = transBig2number(accountInfo.depositAmount);
        this.tableData4[0].price2 = transBig2number(accountInfo.availableAmount);
        this.tableData4[0].price3 = transBig2number(accountInfo.lockedAmount);
      }


    },
    setLimitMax() {
      if (this.isOpenLimit) {
        this.limitNum = this.maxLimit;
      } else {

      }
    },
    setMarketMax() {
      if (this.isOpenMarket) {
        this.marketNum = this.maxMarket;
      }
    },
    async getPositions() {
      if (!this.contractAddress) {
        return;
      }
      let selectToken = await getSelectTokenInfo(this.token);
      let orders = await getContractOrder(this.token,this.contractAddress, selectToken.orderBook);

      let orderIds = await createOrderBookAndCall(selectToken.orderBook, Method.getUserLimitOrdersID,this.token, this.contractAddress)
      let limitOrder = await createTradeAndCall(selectToken.tradeAgent, Method.getLimitOrders, orderIds)

      let maxLongBTC = orders["BTC_1"].size;
      let maxShortBTC = orders["BTC_2"].size;
      let maxLongETH = orders["ETH_1"].size;
      let maxShortETH = orders["ETH_2"].size;

      for (let i in limitOrder) {
        let item = limitOrder[i];
        if (item.offset === 1) {
          continue;
        }
        if (item.name == "BTC" && item.direct == 1) {
          maxLongBTC = maxLongBTC.sub(item.amount)
        } else if (item.name == "BTC" && item.direct == 2) {
          maxShortBTC = maxShortBTC.sub(item.amount)
        } else if (item.name == "ETH" && item.direct == 1) {
          maxLongETH = maxLongETH.sub(item.amount)
        } else if (item.name == "ETH" && item.direct == 2) {
          maxShortETH = maxShortETH.sub(item.amount)
        }
      }
      this.maxLongBTC = maxLongBTC
      this.maxShortBTC = maxShortBTC
      this.maxLongETH = maxLongETH
      this.maxShortETH = maxShortETH

    },
    updatePrice(priceData) {
      if (!priceData) {
        return;
      }
      if (!this.viewInit) {
        return;
      }
      let currPrice = transBig2number(priceData[this.marketValue].price, priceData[this.marketValue].decimal);
      this.currentPrice = currPrice;

      let currLimitPrice = transBig2number(priceData[this.value].price, priceData[this.value].decimal);
      this.currentLimitPrice = currLimitPrice;

      if (this.limitPrice === "") {
        this.limitPrice = currPrice;
      }
    },
    async getMaxLimitAmount() {
      let max = await createTradeAndCall(this.tradeAgent, Method.getMaxAmount,this.token, this.contractAddress, this.value, transNumber2Big(this.limitPrice));
      this.maxLimit = transBig2number(max,18,8,true);
    },
    async getMaxMarketAmount() {
      let max = await createTradeAndCall(this.tradeAgent, Method.getMaxAmount,this.token, this.contractAddress, this.marketValue, transNumber2Big(this.currentPrice));
      this.maxMarket = transBig2number(max,18,8,true);
    },


    async estimateLimitFee() {

      this.estimateMargin(1)
    },
    async estimateMarketFee() {

      this.estimateMargin(2)
    },
    async limitTrade(isBuy) {

      if (this.limitNum <= 0) {
        await this.$message.error(this.$t("quantityMustBePositive"))
        return;
      }
      this.$store.commit('setLoading',true)
      setTimeout(()=>{
        this.$store.commit('setLoading',false)
      },30000)

      let tigger=await getGasReward(this.token,this.value);

      let chain = await getChainId();
      const tx = await createLeadingContractAndSend(
          this.contractAddress, Method.trade,
          [
            this.value, transNumber2Big(this.limitNum),
            transNumber2Big(this.limitPrice),
            1,
            isBuy ? 1 : 2,
            parseInt(new Date().getTime()/1000)+31536000,
            parseInt(new Date().getTime()/1000)+31536000,
            ethers.utils.arrayify("0x"),
          ], tigger);

      emmitMessageWithDelay({msg:MESSAGE.LIMIT_UPDATE,delay:3000})
      if (tx) {
        this.$store.commit('setLoading',false)
        this.limitNum = 0;
        this.$emit("refresh-data");
        this.init()
      }

    },
    async marketTrade(isBuy) {

      if (this.marketNum <= 0) {
        await this.$message.error(this.$t("quantityMustBePositive"))
        return;
      }
      this.$store.commit('setLoading',true)
      setTimeout(()=>{
        this.$store.commit('setLoading',false)
      },30000)

      let tigger=await getGasReward(this.token,this.value);

      let price = await getLastPrice();

      let prices=await getLastPrice();
      let priceData=transBig2number(prices[this.marketValue].price,prices[this.marketValue].decimal);
      let priceBig=BigNumber.from(transNumber2Big(priceData)).mul(BigNumber.from(105)).div(BigNumber.from(100));

      const tx = await createLeadingContractAndSend(
          this.contractAddress, Method.trade,
          [
            this.marketValue, transNumber2Big(this.marketNum),
            isBuy?priceBig.toString():1,
            1,
            isBuy ? 1 : 2,
            parseInt(new Date().getTime()/1000)+31536000,
            parseInt(new Date().getTime()/1000)+15,
            ethers.utils.arrayify(price[this.marketValue].hex)
          ], tigger);
      emmitMessageWithDelay({msg:MESSAGE.POSITION_UPDATE,delay:3000})
      if (tx) {
        this.$store.commit('setLoading',false)
        this.$emit("refresh-data");
        this.marketNum = 0;
        this.init()
      }

    },
    open(openType, isBuy) {
      this.openType = openType
      this.isBuy = isBuy
      if (openType == 1) {
        if (this.limitNum <= 0) {
          this.$message.error(this.$t("quantityMustBePositive"))
          return;
        }
      } else {
        if (this.marketNum <= 0) {
          this.$message.error(this.$t("quantityMustBePositive"))
          return;
        }

      }
      this.dialogVisible = true
    },
    ok1() {
      this.dialogVisible = false
      if (this.openType == 1) {
        if (this.isOpenLimit) {
          this.limitTrade(this.isBuy)
        } else {
          this.closeLimit(this.isBuy)
        }
      } else if (this.openType == 2) {
        if (this.isOpenMarket) {
          this.marketTrade(this.isBuy)
        } else {
          this.closeMarket(this.isBuy)
        }
      }
    },
    async closeLimit(isBuy) {
      this.$store.commit('setLoading', true)

      let tigger=await getGasReward(this.token,this.value)

      let price = "0";
      price = transNumber2Big(this.limitPrice)

      let tx = await createLeadingContractAndSend(this.contractAddress, Method.closeOrder, [this.value, isBuy?this.closeLimitLongAmount.toString():this.closeLimitShortAmount.toString(), 1,
        price, isBuy ? 1 : 2, parseInt(new Date().getTime()/1000)+31536000, parseInt(new Date().getTime()/1000)+31536000, ethers.utils.arrayify("0x")], tigger);

      emmitMessageWithDelay({msg:MESSAGE.LIMIT_UPDATE,delay:3000})
      if (tx) {
        this.init()
      }
    },
    async closeMarket(isBuy) {
      let prices = await getLastPrice();
      let tx = await createLeadingContractAndSend(this.contractAddress, Method.closeOrder, [this.marketValue, isBuy?this.closeMarketLongAmount.toString():this.closeMarketShortAmount.toString(), 0,
        0, isBuy ? 1 : 2, parseInt(new Date().getTime()/1000)+31536000, parseInt(new Date().getTime()/1000)+15, ethers.utils.arrayify(prices[this.marketValue].hex)], await getValue(this.token));
      emmitMessageWithDelay({msg:MESSAGE.POSITION_UPDATE,delay:3000})
      if (tx) {
        this.init()
      }
      this.getPositions()

    },
    async init() {
      this.loading = true
      await this.getDataInfo()
      this.loading = false
    },

    openModal() {
      this.showModal = !this.showModal;
    },
    closeModal() {
      this.showModal = false;
    },
    add(num) {
      this.limitPriceArr.push(parseFloat(this.limitPrice))
      this.limitPrice = parseFloat(this.limitPrice) + num;
    },
    returnPrice() {
      this.limitPrice = this.limitPriceArr.pop();
    },
    clearPrice() {
      this.limitPrice = 0;
    },
    async estimateMargin(type) {
      let price = await getLastPrice()
      //限价
      if (type == 1) {

        this.marginLimit = (parseFloat(transBig2number(price[this.value].price, price[this.value].decimal)) * Number(this.limitNum) / this.levelLimit).toFixed(2);
      } else {
        this.marginMarket = (parseFloat(transBig2number(price[this.marketValue].price, price[this.marketValue].decimal)) * Number(this.marketNum) / this.levelMarket).toFixed(2);
      }
    },
    async getLevelInfo() {
      let selectInfo = await getSelectTokenInfo(this.token)
      this.optionAddress = selectInfo.perpetual;
      if (!this.optionAddress) {
        return;
      }
      let levelBTC = await createPerpOptionAndCall(this.optionAddress, Method.getUserLeverage,this.token, this.contractAddress, "BTC");
      let levelETH = await createPerpOptionAndCall(this.optionAddress, Method.getUserLeverage,this.token, this.contractAddress, "ETH");
      this.levelBTC = parseInt(levelBTC.toString())
      this.levelETH = parseInt(levelETH.toString())

      this.levelLimit = this.value == "BTC" ? this.levelBTC : this.levelETH;
      this.levelMarket = this.marketValue == "BTC" ? this.levelBTC : this.levelETH;
    },
    openLevel(type) {
      this.changeLevel = type == 1 ? this.levelLimit : this.levelMarket;
      this.levelVisible = true;
      this.changeLevelType = type;
    },
    async doChangeLevel() {
      let changeType = "";
      this.levelVisible = false;
      if (this.changeLevelType == 1) {
        changeType = this.value;
      } else {
        changeType = this.marketValue
      }
      if (!this.optionAddress || !changeType) {
        return;
      }
      await createLeadingContractAndSend(this.contractAddress, Method.setUserLeverage, [changeType, this.changeLevel], 0)
      this.getLevelInfo()
    },
    addLevel(type){
      if(type==2){
        if(this.changeLevel<100){
          this.changeLevel++;
        }
      }else if(type==1){
        if(this.changeLevel>0){
          this.changeLevel--;
        }
      }
    }
  },
  directives: {
    'click-outside': {
      bind(el, binding, vnode) {
        el.clickOutsideEvent = function (event) {
          // 检查点击是否发生在元素外部
          if (!(el === event.target || el.contains(event.target))) {
            // 调用绑定的方法
            vnode.context[binding.expression](event);
          }
        };
        // 添加事件监听
        document.body.addEventListener('click', el.clickOutsideEvent);
      },
      unbind(el) {
        // 移除事件监听
        document.body.removeEventListener('click', el.clickOutsideEvent);
      }
    }
  },
  watch: {
    limitPrice(val1, val2) {
      if (this.viewInit) {
        this.getMaxLimitAmount();
        this.estimateLimitFee();
      }

    },
    currentPrice(val1, val2) {
      if (this.viewInit) {
        this.getMaxMarketAmount();
        this.estimateMarketFee();
      }
    },
    limitNum(val) {
      this.estimateLimitFee();
      if(!this.isOpenLimit && !isNaN(Number(val))){
        let closeBig=BigNumber.from(transNumber2Big(val));
        if(this.marketValue=="BTC"){
          this.closeLimitLongAmount=closeBig.gt(this.maxLongBTC)?this.maxLongBTC:closeBig;
          this.closeLimitShortAmount=closeBig.gt(this.maxShortBTC)?this.maxShortBTC:closeBig;
        }else{
          this.closeLimitLongAmount=closeBig.gt(this.maxLongETH)?this.maxLongETH:closeBig;
          this.closeLimitShortAmount=closeBig.gt(this.maxShortETH)?this.maxShortETH:closeBig;
        }
      }
    },
    marketNum(val) {
      this.estimateMarketFee();
      if(!this.isOpenMarket && !isNaN(Number(val))){
        let closeBig=BigNumber.from(transNumber2Big(val));
        if(this.marketValue=="BTC"){
          this.closeMarketLongAmount=closeBig.gt(this.maxLongBTC)?this.maxLongBTC:closeBig;
          this.closeMarketShortAmount=closeBig.gt(this.maxShortBTC)?this.maxShortBTC:closeBig;
        }else{
          this.closeMarketLongAmount=closeBig.gt(this.maxLongETH)?this.maxLongETH:closeBig;
          this.closeMarketShortAmount=closeBig.gt(this.maxShortETH)?this.maxShortETH:closeBig;
        }
      }

    },
    async value(val1) {

      let priceData = await getLastPrice();
      let currLimitPrice = transBig2number(priceData[this.value].price, priceData[this.value].decimal);
      this.currentLimitPrice = currLimitPrice;
      this.limitPrice = currLimitPrice;

      this.getMaxLimitAmount();
      this.estimateLimitFee();
      this.limitNum = 0;
      this.estimateLimit = 0;
      this.foundFeeLimit = 0;
      this.maxLimit = 0;

      this.levelLimit = val1 == "BTC" ? this.levelBTC : this.levelETH;

      if (!this.isOpenLimit) {
        this.closeLimitLongAmount = BigNumber.from(0)
        this.closeLimitShortAmount = BigNumber.from(0)
      }
      this.progressLimit=0;


    },
    async marketValue(val) {

      let priceData = await getLastPrice();
      let currPrice = transBig2number(priceData[this.marketValue].price, priceData[this.marketValue].decimal);
      this.currentPrice = currPrice;

      this.getMaxMarketAmount();
      this.estimateMarketFee();
      this.marketNum = 0;
      this.estimateMarket = 0;
      this.foundFeeMarket = 0;
      this.maxMarket = 0;


      this.levelMarket = val == "BTC" ? this.levelBTC : this.levelETH;

      if (!this.isOpenMarket) {
        this.closeMarketLongAmount = BigNumber.from(0)
        this.closeMarketShortAmount = BigNumber.from(0)
      }
      this.progressMarket=0;
    },
    progressLimit(newVal){
      if (this.isOpenLimit) {
        if (parseFloat(this.maxLimit) === 0) {
          return;
        }
        let limitNum = this.maxLimit * newVal / 100;
        if (Math.abs(this.limitNum - limitNum) > this.maxLimit * 0.01) {
          this.limitNum = parseFloat(limitNum.toFixed(4));
        }

      } else {
        this.limitNum = newVal + "%";
        if (this.value == "BTC") {
          this.closeLimitLongAmount = this.maxLongBTC.mul(BigNumber.from(newVal)).div(100);
          this.closeLimitShortAmount = this.maxShortBTC.mul(BigNumber.from(newVal)).div(100);
        } else {
          this.closeLimitLongAmount = this.maxLongETH.mul(BigNumber.from(newVal)).div(100);
          this.closeLimitShortAmount = this.maxShortETH.mul(BigNumber.from(newVal)).div(100);
        }
      }
    },
    progressMarket(newVal){
      if (this.isOpenMarket) {
        if (parseFloat(this.maxMarket) === 0) {
          return;
        }
        let limitNum = this.maxMarket * newVal / 100;
        if (Math.abs(this.marketNum - limitNum) > this.maxMarket * 0.01) {
          this.marketNum = parseFloat(limitNum.toFixed(4));
        }
      } else {
        this.marketNum = newVal + "%";
        if (this.marketValue == "BTC") {
          this.closeMarketLongAmount = this.maxLongBTC.mul(BigNumber.from(newVal)).div(100);
          this.closeMarketShortAmount = this.maxShortBTC.mul(BigNumber.from(newVal)).div(100);
        } else {
          this.closeMarketLongAmount = this.maxLongETH.mul(BigNumber.from(newVal)).div(100);
          this.closeMarketShortAmount = this.maxShortETH.mul(BigNumber.from(newVal)).div(100);
        }
      }
    },
    isOpenLimit(){
      this.limitNum=""
    },
    isOpenMarket(){
      this.marketNum=""
    },


  },

  created() {
    this.getDataInfo()
    this.getLevelInfo()
    this.getPositions()
  }
}
</script>
<style src="../assets/css/celect.css"></style>
<style src="../assets/list.scss" lang="scss" scoped></style>
<style src="../assets/windows.scss" lang="scss" scoped></style>
<style src="../assets/css/index.scss" lang="scss" scoped></style>
<style lang="scss" scoped>
.el-input__inner {
  color: #A6A6A6 !important;
}

.willHide {
  display: none !important;
}

.level_title {
  color: white;
}

.level {
  display: flex;
  border-radius: 8px;
  border: 1px solid rgba(128, 128, 128, 1);
  height: 40px;
  padding-left: 15px;
  padding-right: 15px;
  color: rgba(128, 128, 128, 1);
  align-items: center;
  font-size: 14px;
  margin-top: 20px;
}

.level_num {
  flex: 1;
  text-align: center;
}

.level_add, .level_sub {
  font-size: 20px;
  cursor: pointer;
}

.level_confirm {
  width: 100%;
  height: 44px;
  margin-top: 40px;
  margin-left: auto;
  border-radius: 8px;
  margin-right: auto;
  border: 1px solid rgba(198, 254, 97, 1);
  background: rgba(198, 254, 97, 1);
  font-size: 15px;
  font-weight: 500;
  color: black;
  line-height: 44px;
  text-align: center;
  cursor: pointer;
}

.title_box {
  display: flex;
  gap: 24px;
  margin-bottom: 30px;
  margin-left: -12px;

  .contract_type {
    width: 96px;
    height: 32px;
    border-radius: 8px;
    background: rgba(38, 40, 44, 1);
    font-size: 15px;
    color: rgba(234, 236, 239, 1);
    font-family: "思源黑体";
    text-align: center;
    line-height: 32px;
  }

  .contract_level {
    width: 96px;
    height: 32px;
    border-radius: 8px;
    background: rgba(69, 73, 82, 1);
    font-size: 15px;
    color: rgba(234, 236, 239, 1);
    font-family: "思源黑体";
    text-align: center;
    line-height: 32px;
    cursor: pointer;
  }
}

.openC {
  border-radius: 6px;
  height: 26px;
  margin-top: 19px;
  position: relative;
  margin-bottom: 20px;

  .openItem {
    width: 50%;

    .openItemTitle {
      text-align: center;
      display: inline-block;
      line-height: 26px;
      font-size: 12px;
      font-weight: 700;
      width: 100%;
      cursor: pointer;
      color: #202630;

      &.active {
        background: rgba(174, 177, 184, 1);
      }

      &.darkMode {
        color: #FFFFFFFF;

        &.active {
          background: #474D57FF;
        }
      }

    }
  }

  .openItemBox {
    height: 20px;
    width: 20px;
    margin-left: -10px;
    position: absolute;
    margin-top: 4px;
    display: inline-block;
    transform: rotate(45deg);
    border-radius: 4px;
    background: rgba(174, 177, 184, 1);

    &.darkMode {
      background: #474D57FF;
    }
  }

  .open {
    float: left;

    .openTitle {
      border-top-left-radius: 6px;
      border-bottom-left-radius: 6px;
      border-left: 1.3px solid #AEB1B8;
      border-top: 1.3px solid #AEB1B8;
      border-bottom: 1.3px solid #AEB1B8;

      &.darkMode {
        border-left: 1.3px solid #808080FF;
        border-top: 1.3px solid #808080FF;
        border-bottom: 1.3px solid #808080FF;

        &.active {
          border-color: #474D57;
        }
      }

      border-right: 0 none;
    }
  }

  .close {
    float: right;

    .closeTitle {
      border-top-right-radius: 6px;
      border-bottom-right-radius: 6px;

      border-right: 1.3px solid #AEB1B8;
      border-top: 1.3px solid #AEB1B8;
      border-bottom: 1.3px solid #AEB1B8;

      &.darkMode {
        border-right: 1.3px solid #808080FF;
        border-top: 1.3px solid #808080FF;
        border-bottom: 1.3px solid #808080FF;

        &.active {
          border-color: #474D57;
        }
      }

      border-left: 0 none;
    }

  }
}

.list_box {
  margin-top: 30px;

  .titile {
    color: #C6FE61;
    font-size: 16px;
    font-weight: 700;
    height: 32px;
    white-space: nowrap;
    border-bottom: 1px solid rgba(234, 236, 239, 0.2);
    text-underline: rgba(198, 254, 97, 1);
    text-decoration: underline;
    text-underline-offset: 16px;
  }

  .top_box {
    margin-top: 24px;

    .jyd {


      .jyd_select {
        width: 118px;
      }

      span {
        font-size: 15px;
        font-weight: 500;
        color: #EAECEF;
        margin-right: 10px;
      }
    }

    .price {
      font-weight: 500;
      width: 150px;
      text-align: right;
      min-width: 150px;

      span {
        color: rgba(132, 142, 156, 1);
      }
    }

    .list {
      .left {
        position: relative;
      }
    }
  }
}

.order_price_box {
  color: #A6A6A6;
  position: relative;

  .grid_box {
    display: flex;
    position: absolute;
    background-color: #17191b;
    box-shadow: 0px 10px 25px #000000 !important;
    width: 200px;
    flex-wrap: wrap;
    z-index: 999999;
    border-radius: 10px;
    right: 0;
    top: 40px;

    .grid_list {
      width: calc(50% - 1px);
      font-size: 14px;
      border-bottom: 1px solid #A6A6A6;
      color: #A6A6A6;
      text-align: center;
      cursor: pointer;
      display: flex;
      align-items: center;
      justify-content: center;

      svg {
        width: 20px;
      }
    }

    .grid_list:nth-child(odd) {
      border-right: 1px solid #A6A6A6;
    }
  }
}

.activate4_box .list_box .list .left span {
  color: #A6A6A6;
}


.slider-container {
  width: 100%;
  height: 3px;
  background-color: #ccc;
  position: relative;
  margin-top: 30px;

  .ct_box {
    position: absolute;
    z-index: 1;
    width: 100%;
    margin-top: -5px;

    .aaa {
      width: 12px;
      height: 12px;
      margin-right: calc(25% - 15px);
    }

    img {
      width: 12px;
      height: 12px;
      min-width: 12px;
      min-height: 12px;
    }
  }
}

.slider-bar {
  height: 100%;
  width: 0;
  /* This will be updated dynamically */
  background-color: #C6FE61;
  position: absolute;
  left: 0;
  top: 0;
}

.slider-handle {
  width: 30px;
  height: 30px;
  border: 1px solid #ccc;
  border-radius: 50%;
  position: absolute;
  top: 50%;
  transform: translateY(-50%);
  left: 0;
  /* This will be updated dynamically */
  cursor: pointer;
  z-index: 10;
  background-color: #181A20;
}

::v-deep .el-dialog__footer {
  padding: 0px 24px 22px !important;
}

::v-deep .el-dialog {
  width: 380px !important;
}

@media (max-width: 750px) {
  ::v-deep .el-dialog {
    width: 80% !important;
  }
}
</style>
<style>
.el-table,
.el-table__expanded-cell {
  background-color: rgba(24, 26, 32, 1);
}
</style>
<style scoped lang="scss">
.select_down {
  ::v-deep .el-input__suffix {
    .el-input__suffix-inner {
      .el-select__caret {
        font-family: 'element-icons' !important; // 确保使用 Element UI 的字体

        &.el-icon-arrow-up::before {
          content: "\e78f"; // 替换为你想用的 Element UI 图标的 Unicode 编码
        }

        &.el-icon-arrow-down::before {
          content: "\e790"; // 和展开时使用同一个图标的 Unicode
        }
      }
    }
  }
}
</style>